import { Icon } from 'antd'
import api, { AppFormItem as AppFormItemProps, MetadataAttribute } from 'api/index'
import AppDialog from 'components/AppDialog'
import AppMessage from 'components/AppMessage'
import Ruler from 'components/AppRuler/Ruler'
import { AppTabs } from 'components/AppTabs'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { isNumberType } from 'utils'
import {
	AppFormAction,
	AppGridAdvancedSearchItem,
	AppGridCommonSearchItem,
	AppGridView,
	AppTableCol,
} from '../../../../api/index'
import { isDateType } from '../../../../utils/index'
import { AppGridLayoutDesigerContext } from './AppGridLayoutDesigerContext'
import { ButtonAction } from './ButtonAction'
import { ButtonDrag } from './ButtonDrag'
import { FieldSelect } from './FieldSelect'
import { OptionSet } from './OptionSet'
import { EmptyPropertyForm, PropertyForm } from './PropertyForm'
import AppMultAction from 'components/AppAction/AppMultAction'

export const AppGridLayoutBodyDesiger = () => {
	const renderBody = () => {
		const context = useContext(AppGridLayoutDesigerContext)
		switch (context.view) {
			case '数据来源':
				return <DataSource />
			case '列表设计':
				return <Desiger />
			default:
				return <Desiger />
		}
	}
	return (
		<div className="app-grid-layout-body-desiger">
			<div className="app-grid-layout-body-inner">{renderBody()}</div>
		</div>
	)
}

const DataSource = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const [tableViewId, setTableViewId] = useState(context.tableViewId)
	useEffect(() => {
		setTableViewId(context.tableViewId)
	}, [context.tableViewId])
	const chgSql = async (sql: string) => {
		let metadataGird = context.metadataGird
		metadataGird.appGridLayout.appGridViewList[tableViewId].appTable.apiPath = '/api/modeling/appGrid/loadData'
		metadataGird.appGridLayout.appGridViewList[tableViewId].appTable.type = 'sql'
		metadataGird.appGridLayout.appGridViewList[tableViewId].appTable.sqlCommand = sql
		context.setMetadataGrid({ ...metadataGird })
		await api.modeling.appgrid.delSql({ sql })
	}
	return (
		<div className="app-grid-layout-data-source">
			<div className="app-grid-layout-data-sql">
				<div className="app-grid-layout-data-sql-heard">
					<div className="app-grid-layout-data-sql-heard-left">
						<span className="app-grid-layout-data-sql-heard-item">
							<label>数据表</label>
							{context.metadataGird.appGridLayout.entityName}
						</span>
					</div>
					<div className="app-grid-layout-data-sql-heard-right">
						<span className="app-grid-layout-data-sql-heard-item">
							<a target="_blank" href={`/modeling/entity/` + context.metadataGird.appGridLayout.entityId}>
								修改数据表
							</a>
						</span>
					</div>
				</div>
				<div className="app-grid-layout-data-sql-content">
					<div className="app-grid-layout-data-sql-editor">
						<div className="app-grid-layout-data-sql-editor-heard">
							<span className="app-grid-layout-data-sql-editor-title">SQL</span>
							<div className="app-grid-layout-data-sql-editor-toolbar">
								<div className="app-grid-layout-data-sql-editor-toolbar-item">
									<AppMultAction
										title={context.metadataGird.appGridLayout.appGridViewList[tableViewId].title}
										rightIcon="down"
									>
										{context.metadataGird.appGridLayout.appGridViewList.map(
											(appGridView: AppGridView, index: number) => {
												return (
													<AppMultAction.Item
														key={appGridView.viewId}
														title={appGridView.title}
														action={e => setTableViewId(index)}
													/>
												)
											}
										)}
									</AppMultAction>
								</div>
							</div>
						</div>
						<div className="app-grid-layout-data-sql-editor-content">
							<textarea
								key={tableViewId}
								className="app-grid-layout-data-sql-editor-content-textarea"
								defaultValue={
									context.metadataGird.appGridLayout.appGridViewList[tableViewId].appTable
										.sqlCommand || ''
								}
								onBlur={e => chgSql(e.target.value)}
							></textarea>
						</div>
					</div>
					<div className="app-grid-layout-data-sql-panel">
						<div className="app-grid-layout-data-sql-desc">
							<h4>关键字格式</h4>
							<ul>
								<li>
									<span>表单主键：@oid</span>
								</li>
								<li>
									<span>
										系统函数：[key:XXX]
										<div className="mp-help-tooltip">
											<i className="mp-icon-help el-tooltip"></i>
										</div>
									</span>
									<cite>例如[key:本人]</cite>
								</li>
								<li>
									<span>URL参数：[query]</span> <cite>例如[query:ProjGUID]</cite>
								</li>
								<li>
									<span>业务参数：[bizparam:XXX]</span> <cite>例如[bizparam:单价保留位]</cite>
								</li>
								<li>
									<span>{`项目过滤：{项目过滤|表英文名.字段英文名|}`}，必须放在表之后</span>
									<cite>{'例如：FROM x_Order as x_Order {项目过滤|x_Order.x_ProjGUID|}'}</cite>
								</li>
								<li>
									<span>自定义SQL脚本，必须在 WHERE 后面增加 (1=1) 条件</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
const Desiger = () => {
	return (
		<div className="app-grid-layout-body-desiger">
			<MainDesiger />
			<MainProperty />
		</div>
	)
}

const MainDesiger = () => {
	return (
		<div className="app-grid-layout-body-main-desiger">
			<div className="app-grid-layout-body-main-inner">
				<div className="grid-desiger">
					<SearchDesiger />
					<ViewDesiger />
				</div>
			</div>
		</div>
	)
}

const ViewDesiger = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const appGridViewList = context.metadataGird.appGridLayout.appGridViewList || []
	let appActionList = context.metadataGird.appGridLayout.appGridHeard.appGridMenu.appActionList || []
	let currAppGridView = context.metadataGird.appGridLayout.appGridViewList[context.tableViewId]
	let appTableColList = currAppGridView.appTable.appTableColList || []
	let tableActionList = currAppGridView.appTable.tableActionList || []
	const maxViewId = appGridViewList
		.map(appGridView => appGridView.viewId)
		.reduce((a, b) => {
			return a > b ? a : b
		})
	const copyView = (appGridView: AppGridView) => {
		let metadataGird = context.metadataGird
		let appGridViewNew = JSON.parse(JSON.stringify(appGridView))
		appGridViewNew.title = appGridView.title + '-副本'
		appGridViewNew.viewId = maxViewId + 1
		appGridViewList.push(appGridViewNew)
		metadataGird.appGridLayout.appGridViewList = appGridViewList
		context.setMetadataGrid({ ...metadataGird })
	}
	const delView = async (e: any, appGridView: AppGridView, index: number) => {
		e.nativeEvent.stopImmediatePropagation()
		e.stopPropagation()
		if (await AppMessage.confirm('确定要删除此视图吗？', true)) {
			let metadataGird = context.metadataGird
			let appGridViewListNew = appGridViewList.filter(t => t.viewId !== appGridView.viewId)

			metadataGird.appGridLayout.appGridViewList = appGridViewListNew
			if (index === context.tableViewId) {
				context.setTableViewId(0)
			} else if (index < context.tableViewId) {
				context.setTableViewId(context.tableViewId - 1)
			}
			context.setMetadataGrid({ ...metadataGird })
		}
	}
	const addRightButton = () => {
		let metadataGird = context.metadataGird
		appActionList.push({ title: '新建' })
		metadataGird.appGridLayout.appGridHeard.appGridMenu.appActionList = appActionList
		context.setMetadataGrid({ ...metadataGird })
	}
	const delRightButton = (index: number) => {
		let metadataGird = context.metadataGird
		appActionList.splice(index, 1)
		metadataGird.appGridLayout.appGridHeard.appGridMenu.appActionList = appActionList
		context.setMetadataGrid({ ...metadataGird })
	}
	const addRowButton = () => {
		let metadataGird = context.metadataGird
		tableActionList.push({ title: '新建' })
		metadataGird.appGridLayout.appGridViewList[context.tableViewId].appTable.tableActionList = tableActionList
		context.setMetadataGrid({ ...metadataGird })
	}
	const chgButton = (buttonList: AppFormAction[], type: string) => {
		let metadataGird = context.metadataGird
		if (type === 'rightButton') {
			metadataGird.appGridLayout.appGridHeard.appGridMenu.appActionList = buttonList
		} else {
			currAppGridView.appTable.tableActionList = buttonList
		}
		context.setMetadataGrid({ ...metadataGird })
	}
	const chgAppTableColList = (selectedField: MetadataAttribute) => {
		let metadataGird = context.metadataGird
		if (appTableColList && appTableColList.find(s => s.field === selectedField.name)) {
			appTableColList = appTableColList.filter(s => s.field !== selectedField.name)
		} else {
			appTableColList.push({
				field: selectedField.name,
				title: selectedField.displayName,
				width: 110,
			})
		}
		currAppGridView.appTable.appTableColList = appTableColList
		context.setMetadataGrid({ ...metadataGird })
	}
	const delField = (field: string) => {
		let metadataGird = context.metadataGird
		appTableColList = appTableColList.filter(s => s.field !== field)
		currAppGridView.appTable.appTableColList = appTableColList
		context.setMetadataGrid({ ...metadataGird })
	}
	return (
		<div className="group">
			<div className="group-title">
				<div className="group-title-icon" />
				视图
			</div>
			<div className="group-content">
				<div className="view-desiger">
					<div className="nav-tabs view">
						{appGridViewList.map((appGridView: AppGridView, index: number) => {
							return (
								<div
									key={appGridView.viewId}
									title="点击编辑，拖动交换位置"
									className={`tab active ${
										context.currSelectd.type === 'view' &&
										context.currSelectd.field === appGridView.viewId.toString()
											? 'chosen'
											: ''
									}`}
									draggable="false"
									onClick={e => {
										context.setCurrSelected({ type: 'view', field: appGridView.viewId.toString() })
										context.setTableViewId(index)
									}}
								>
									<span className="name">{appGridView.title}</span>
									{appGridViewList.length > 1 ? (
										<Icon
											type="close"
											className="remove"
											onClick={e => delView(e, appGridView, index)}
										></Icon>
									) : (
										''
									)}
								</div>
							)
						})}
						<div className="addition">
							<AppMultAction title="新增视图" rightIcon="down">
								{appGridViewList.map((appGridView: AppGridView) => {
									return (
										<AppMultAction.Item
											key={appGridView.viewId}
											title={`复制${appGridView.title}`}
											action={e => copyView(appGridView)}
										></AppMultAction.Item>
									)
								})}
							</AppMultAction>
						</div>
					</div>
					<div className="view-container">
						<div className="view-panel view">
							<div className="global-toolbar-container">
								<div className="toolbar-container">
									<div className="toolbar-items-content global-left"></div>
									<div className="toolbar-items-content global-right">
										<div style={{ marginRight: 10, display: 'inline-block' }}>
											<FieldSelect
												fieldList={context.metadataEntity.metadataAttributeList}
												selectedFieldList={appTableColList.map(item => {
													return { name: item.field }
												})}
												onChange={chgAppTableColList}
											/>
										</div>

										<AppMultAction
											title="新增右侧按钮"
											leftIcon="plus-circle"
											leftIconStyle={{ fontSize: '18px', color: '#34a6f8', paddingRight: '5px' }}
										>
											<AppMultAction.Item
												title="新增按钮"
												action={addRightButton}
											></AppMultAction.Item>
										</AppMultAction>
										<ButtonDrag
											type="rightButton"
											appActionList={appActionList}
											onChange={chgButton}
										/>
									</div>
								</div>
							</div>
							<div className="action action-column">
								<div className="action-body">
									<div className="column-container" style={{ width: 'auto' }}>
										<div className="columns">
											<div className="column-list">
												{appTableColList.map((appTableCol: AppTableCol) => {
													return (
														<div
															key={appTableCol.field}
															className={`column-item ${
																context.currSelectd.type === 'field' &&
																context.currSelectd.field === appTableCol.field
																	? 'chosen'
																	: ''
															}`}
															title={`${appTableCol.field}(${appTableCol.title})
点击编辑，拖动交换位置`}
															draggable="false"
															style={{ width: '174px' }}
															onClick={e =>
																context.setCurrSelected({
																	type: 'field',
																	field: appTableCol.field,
																})
															}
														>
															<span>{appTableCol.title}</span>
															<Icon
																type="close"
																className="remove"
																onClick={e => delField(appTableCol.field)}
															></Icon>
														</div>
													)
												})}
											</div>
											<Ruler />
											<div className="column-zone">数据显示区域</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="global-toolbar-container">
							<div className="toolbar-container">
								<div className="toolbar-items-content global-left"></div>
								<div className="toolbar-items-content global-right">
									<AppMultAction
										title="新增行按钮"
										leftIcon="plus-circle"
										leftIconStyle={{ fontSize: '18px', color: '#34a6f8', paddingRight: '5px' }}
									>
										<AppMultAction.Item title="新增按钮" action={addRowButton}></AppMultAction.Item>
									</AppMultAction>
									<ButtonDrag type="rowButton" appActionList={tableActionList} onChange={chgButton} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const SearchDesiger = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appGridCommonSearchItemList =
		context.metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList || []
	let appGridAdvancedSearchItemList =
		context.metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList || []
	const chgCommonSearchItemList = (selectedField: any) => {
		let metadataGird = context.metadataGird
		if (appGridCommonSearchItemList && appGridCommonSearchItemList.find(s => s.field === selectedField.name)) {
			appGridCommonSearchItemList = appGridCommonSearchItemList.filter(s => s.field !== selectedField.name)
		} else {
			appGridCommonSearchItemList.push({
				keyName: selectedField.name,
				field: selectedField.name,
				label: selectedField.displayName,
				dataType: isNumberType(selectedField.dbType) ? 'number' : 'string',
			})
		}
		metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList = appGridCommonSearchItemList
		context.setMetadataGrid({ ...metadataGird })
	}
	const chgAdvancedSearchItemList = (selectedField: MetadataAttribute) => {
		let metadataGird = context.metadataGird
		if (appGridAdvancedSearchItemList && appGridAdvancedSearchItemList.find(s => s.field === selectedField.name)) {
			appGridAdvancedSearchItemList = appGridAdvancedSearchItemList.filter(s => s.field !== selectedField.name)
		} else {
			appGridAdvancedSearchItemList.push({
				keyName: selectedField.name,
				field: selectedField.name,
				label: selectedField.displayName,
				dataType: isNumberType(selectedField.dbType) ? 'number' : 'string',
				type: isNumberType(selectedField.dbType)
					? 'numberRange'
					: isDateType(selectedField.dbType)
					? 'dateRange'
					: 'text',
			})
		}
		metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList = appGridAdvancedSearchItemList
		context.setMetadataGrid({ ...metadataGird })
	}

	const delCommonSearchItem = (item: any) => {
		let metadataGird = context.metadataGird
		metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList = appGridCommonSearchItemList.filter(
			e => e.field !== item.field
		)
		context.setMetadataGrid({ ...metadataGird })
	}

	const delAdvancedSearchItem = (item: any) => {
		let metadataGird = context.metadataGird
		metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList = appGridAdvancedSearchItemList.filter(
			e => e.field !== item.field
		)
		context.setMetadataGrid({ ...metadataGird })
	}
	return (
		<div className="group">
			<div className="group-title">
				<div className="group-title-icon" />
				搜索
			</div>
			<div className="group-content">
				<div className="common-search">
					<div
						className={`project-filter ${context.currSelectd.type === 'projectFilter' ? 'chosen' : ''}`}
						onClick={e => context.setCurrSelected({ type: 'projectFilter' })}
					>
						<label>{context.metadataGird.appGridLayout.appGridSearch.projectFilterLabel}</label>
						<div className="ui dropdown disabled">
							<div className="text">项目控件</div>
							<Icon type="down" className="icon dropdown" />
						</div>
					</div>
					<div className="quick-filter">
						<div className="quick-filter-label">普通查询</div>
						<div className="quick-filter-drag">
							{appGridCommonSearchItemList.map((appGridCommonSearchItem: AppGridCommonSearchItem) => {
								return (
									<div
										key={appGridCommonSearchItem.field}
										className={`ui button ${
											context.currSelectd.type === 'quickFilterField' &&
											context.currSelectd.field === appGridCommonSearchItem.field
												? 'chosen'
												: ''
										}`}
										draggable="false"
										onClick={e =>
											context.setCurrSelected({
												type: 'quickFilterField',
												field: appGridCommonSearchItem.field,
											})
										}
									>
										<span title="点击编辑，拖动交换位置">{appGridCommonSearchItem.label}</span>
										<Icon
											type="close"
											className="remove"
											onClick={e => delCommonSearchItem(appGridCommonSearchItem)}
										></Icon>
									</div>
								)
							})}
						</div>
						<div className="quick-filter-dropdown">
							<FieldSelect
								fieldList={context.metadataEntity.metadataAttributeList}
								selectedFieldList={appGridCommonSearchItemList.map(item => {
									return { name: item.field }
								})}
								onChange={chgCommonSearchItemList}
							/>
						</div>
					</div>
				</div>
				<div className="advanced-filter">
					<div
						className={`ui button action-label ${
							context.currSelectd.type === 'advancedFilter' ? 'chosen' : ''
						}`}
						onClick={e => context.setCurrSelected({ type: 'advancedFilter' })}
					>
						高级搜索
					</div>
					<div className="advanced-filter-drag">
						{appGridAdvancedSearchItemList.map((appGridAdvancedSearchItem: AppGridAdvancedSearchItem) => {
							return (
								<div
									key={appGridAdvancedSearchItem.field}
									className={`ui button ${
										context.currSelectd.type === 'advancedFilterField' &&
										context.currSelectd.field === appGridAdvancedSearchItem.field
											? 'chosen'
											: ''
									}`}
									draggable="false"
									onClick={e =>
										context.setCurrSelected({
											type: 'advancedFilterField',
											field: appGridAdvancedSearchItem.field,
										})
									}
								>
									<span title="点击编辑，拖动交换位置">{appGridAdvancedSearchItem.label}</span>
									<Icon
										type="close"
										className="remove"
										onClick={e => delAdvancedSearchItem(appGridAdvancedSearchItem)}
									></Icon>
								</div>
							)
						})}
					</div>
					<div className="advanced-filter-dropdown">
						<FieldSelect
							fieldList={context.metadataEntity.metadataAttributeList}
							selectedFieldList={appGridAdvancedSearchItemList.map(item => {
								return { name: item.field }
							})}
							onChange={chgAdvancedSearchItemList}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

const MainProperty = () => {
	const [propertyType, setPropertyType] = useState(0)
	const context = useContext(AppGridLayoutDesigerContext)
	const [tabKey, setTabKey] = useState(Math.random())
	useEffect(() => {
		chgPropertyType(0)
		setTabKey(Math.random())
	}, [context.currSelectd])
	const chgPropertyType = (index: number) => {
		setPropertyType(index)
	}
	return (
		<div className="app-grid-layout-body-main-propert">
			<AppTabs key={tabKey} tabs={['组件属性', '控件属性']} defaultIndex={0} onChange={chgPropertyType}></AppTabs>
			{propertyType === 0 ? <ComponentProperty /> : <PageProperty />}
		</div>
	)
}

// interface PropertyProps {}
const PageProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const [entityList, setEntityList] = useState([])
	const loadEntityList = async () => {
		let res = await api.modeling.entity.getList({ systemCode: '00' })
		setEntityList(res)
	}
	const chgPageProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		let metadataGird = context.metadataGird
		let formData = {
			...{
				name: metadataGird.name,
				entityId: metadataGird.appGridLayout.entityId,
				entityName: metadataGird.appGridLayout.entityName,
			},
			...chgData,
		}

		metadataGird.name = formData.name
		metadataGird.appGridLayout.entityId = formData.entityId
		metadataGird.appGridLayout.entityName = formData.entityName
		if (propertyFormItem.field === 'entityId') {
			metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList = []
			metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList = []
			metadataGird.appGridLayout.appGridViewList.map((appGridView: AppGridView) => {
				appGridView.appTable.appTableColList = []
				return appGridView
			})
		}

		metadataGird.name = formData.name
		metadataGird.appGridLayout.entityId = formData.entityId
		metadataGird.appGridLayout.entityName = formData.entityName
		if (propertyFormItem.field === 'entityId') {
			metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList = []
			metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList = []
			metadataGird.appGridLayout.appGridViewList.map((appGridView: AppGridView) => {
				appGridView.appTable.appTableColList = []
				appGridView.appTable.sqlCommand = `SELECT * FROM ${formData.entityName}`
				return appGridView
			})
		}
		context.setMetadataGrid({ ...metadataGird })
		context.loadFieldList({ ...metadataGird })
	}
	useEffect(() => {
		loadEntityList()
	}, [])
	let propertyFormItemList = [
		{ field: 'name', isSave: true, req: true, label: '列表名称', type: 'Input' },
		{
			field: 'entityId',
			textField: 'entityName',
			isSave: true,
			isSaveText: true,
			req: true,
			label: '实体名称',
			type: 'Select',
			dataType: 'number',
			appFormItemOptionList: entityList,
			appFormItemOptionLabelField: 'name',
			appFormItemOptionValueField: 'id',
		},
	] as AppFormItemProps[]
	return (
		<PropertyForm
			formData={{
				name: context.metadataGird.name,
				entityId: context.metadataGird.appGridLayout.entityId,
				entityName: context.metadataGird.appGridLayout.entityName,
			}}
			onChange={chgPageProperty}
			propertyFormItemList={propertyFormItemList}
		/>
	)
}

const ComponentProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)

	const rendComponentProperty = () => {
		switch (context.currSelectd.type) {
			case 'projectfilter':
				return <ProjectFilterProperty />
			case 'quickFilterField':
				return <QuickFilterFieldProperty />
			case 'advancedFilter':
				return <AdvancedFilterProperty />
			case 'advancedFilterField':
				return <AdvancedFilterFieldProperty />
			case 'view':
				return <ViewProperty />
			case 'rightButton':
				return <ButtonProperty type="rightButton" />
			case 'rowButton':
				return <ButtonProperty type="rowButton" />
			case 'field':
				return <FieldProperty />
			default:
				return <ProjectFilterProperty />
		}
	}
	return <Fragment>{rendComponentProperty()}</Fragment>
}

const FieldProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appGridViewList = context.metadataGird.appGridLayout.appGridViewList[
		context.tableViewId
	].appTable.appTableColList.filter(e => e.field === context.currSelectd.field)
	if (!appGridViewList || appGridViewList.length !== 1) return <EmptyPropertyForm />
	let appGridView = appGridViewList[0]
	let formData = {
		title: appGridView.title,
		width: appGridView.width || 110,
	}
	let propertyFormItemList = [
		{ field: 'title', isSave: true, req: true, label: '列名称', type: 'Input' },
		{ field: 'width', isSave: true, req: true, label: '列宽度', type: 'Input', dataType: 'number', format: '#0' },
	] as AppFormItemProps[]
	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let metadataGird = context.metadataGird
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		formData = {
			...formData,
			...chgData,
		}
		appGridView.title = formData.title
		appGridView.width = formData.width
		context.setMetadataGrid({ ...metadataGird })
	}
	return (
		<PropertyForm
			key={context.tableViewId + context.currSelectd.field}
			formData={formData}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

interface ButtonPropertyProps {
	type: string
}
const ButtonProperty = (props: ButtonPropertyProps) => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appAction = (context.metadataGird.appGridLayout.appGridHeard.appGridMenu.appActionList || [])[
		context.currSelectd.field
	]
	if (props.type === 'rowButton') {
		appAction = (context.metadataGird.appGridLayout.appGridViewList[context.tableViewId].appTable.tableActionList ||
			[])[context.currSelectd.field]
	}
	if (!appAction) return <EmptyPropertyForm />
	let formData = {
		title: appAction.title,
		isHighlight: appAction.isHighlight,
		isDisabled: appAction.isDisabled,
		isHidden: appAction.isHidden,
		ActionButton: {
			page: appAction.page,
			PageOptionValueField: appAction.PageOptionValueField,
			buttonType: appAction.buttonType,
			dataSource: appAction.dataSource,
			openType: appAction.openType,
			height: appAction.height,
			width: appAction.width,
		},
	}

	let propertyFormItemList = [
		{ field: 'title', isSave: true, req: true, label: '按钮名称', type: 'Input' },
		{
			field: 'isHighlight',
			isSave: true,
			req: true,
			label: '是否高亮',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'isDisabled',
			isSave: true,
			req: true,
			label: '是否禁用',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'isHidden',
			isSave: true,
			req: true,
			label: '是否隐藏',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'ActionButton',
			isSave: true,
			req: true,
			label: '定义按钮行为',
			type: 'Button',
			labelHidden: true,
		},
	]

	const chgActionButton = (data: any) => {
		let metadataGird = context.metadataGird
		appAction.name = data.name // click
		appAction.type = data.type // page ,action
		appAction.openType = data.openType // // self,dialog,panel,blank
		appAction.pageUrl = data.pageUrl // self blank
		appAction.component = data.component // dialog panel
		appAction.actionType = data.actionType // save close
		appAction.paramlist = data.paramlist

		appAction.height = data.height
		appAction.width = data.width
		context.setMetadataGrid({ ...metadataGird })
		//
	}

	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let metadataGird = context.metadataGird
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		formData = {
			...formData,
			...chgData,
		}
		appAction.title = formData.title
		appAction.isHighlight = formData.isHighlight
		appAction.isDisabled = formData.isDisabled
		appAction.isHidden = formData.isHidden
		if (propertyFormItem.field === 'ActionButton') {
			AppDialog.open(<ButtonAction callback={chgActionButton} {...formData.ActionButton} />, {
				width: 800,
				height: 600,
				title: '定义按钮行为',
			})
			return
		}
		context.setMetadataGrid({ ...metadataGird })
	}
	return (
		<PropertyForm
			key={context.currSelectd.type + context.currSelectd.field}
			formData={formData}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

const ViewProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appGridView = context.metadataGird.appGridLayout.appGridViewList.find(
		e => e.viewId.toString() === context.currSelectd.field
	)
	if (!appGridView) return <EmptyPropertyForm />
	let formData = {
		title: appGridView.title,
		showIndexColumn: appGridView.appTable.showIndexColumn,
		multiSelect: appGridView.appTable.multiSelect,
		colActionWidth: appGridView.appTable.colActionWidth,
		isDefault: context.metadataGird.appGridLayout.defaultViewId === appGridView.viewId,
	}
	let propertyFormItemList = [
		{ field: 'title', isSave: true, req: true, label: '视图名称', type: 'Input' },
		{
			field: 'showIndexColumn',
			isSave: true,
			req: true,
			label: '显示序号列',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'multiSelect',
			isSave: true,
			req: true,
			label: '允许多选',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'isDefault',
			isSave: true,
			req: true,
			label: '是否默认',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'colActionWidth',
			isSave: true,
			req: true,
			label: '操作列宽度',
			type: 'Input',
			dataType: 'number',
			format: '#0',
		},
	]
	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let metadataGird = context.metadataGird
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		formData = {
			...formData,
			...chgData,
		}
		appGridView.title = formData.title
		appGridView.appTable.showIndexColumn = formData.showIndexColumn
		appGridView.appTable.multiSelect = formData.multiSelect
		appGridView.appTable.colActionWidth = formData.colActionWidth
		metadataGird.appGridLayout.defaultViewId = formData.isDefault
			? appGridView.viewId
			: metadataGird.appGridLayout.defaultViewId
		context.setMetadataGrid({ ...metadataGird })
	}
	return (
		<PropertyForm
			key={context.currSelectd.field}
			formData={formData}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

const AdvancedFilterFieldProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appGridAdvancedSearchItem = context.metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.appGridAdvancedSearchItemList.find(
		item => item.field === context.currSelectd.field
	)
	if (!appGridAdvancedSearchItem) return <EmptyPropertyForm />
	let formData = {
		label: appGridAdvancedSearchItem.label,
		type: appGridAdvancedSearchItem.type,
		showMoreItem: appGridAdvancedSearchItem.showMoreItem,
		option: {
			optionType: appGridAdvancedSearchItem.optionType,
			sql: appGridAdvancedSearchItem.sql,
			apiPath: appGridAdvancedSearchItem.apiPath,
			dataList: appGridAdvancedSearchItem.appGridAdvancedSearchItemOptionList,
		},
	}

	const chgSearchItem = (data: any) => {
		let metadataGird = context.metadataGird
		appGridAdvancedSearchItem.optionType = data.optionType
		appGridAdvancedSearchItem.sql = data.sql
		appGridAdvancedSearchItem.apiPath = data.apiPath
		appGridAdvancedSearchItem.appGridAdvancedSearchItemOptionList = data.dataList
		context.setMetadataGrid({ ...metadataGird })
	}

	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		if (propertyFormItem.field === 'option') {
			AppDialog.open(<OptionSet callback={chgSearchItem} {...formData.option} />, {
				width: 600,
				height: 400,
				title: '定义备选项',
			})
			return
		}
		let metadataGird = context.metadataGird
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		formData = {
			...formData,
			...chgData,
		}
		appGridAdvancedSearchItem.label = formData.label
		appGridAdvancedSearchItem.type = formData.type
		appGridAdvancedSearchItem.showMoreItem = formData.showMoreItem
		context.setMetadataGrid({ ...metadataGird })
	}
	let propertyFormItemList = [
		{ field: 'label', isSave: true, req: true, label: '显示名称', type: 'Input' },
		{
			field: 'type',
			isSave: true,
			req: true,
			label: '显示方式',
			type: 'Select',
			appFormItemOptionList: [
				{ label: '文本输入', value: 'text' },
				{ label: '选项列表', value: 'select' },
				{ label: '数值区间', value: 'numberRange' },
				{ label: '日期区间', value: 'dateRange' },
			],
		},
		{
			field: 'showMoreItem',
			isSave: true,
			req: true,
			isHidden: formData.type === 'select' ? false : true,
			label: '是否默认展开',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'option',
			isSave: true,
			req: true,
			isHidden: formData.type === 'select' ? false : true,
			label: '定义备选项',
			type: 'Button',
			labelHidden: true,
		},
	] as AppFormItemProps[]
	return (
		<PropertyForm
			key={context.currSelectd.field}
			formData={formData}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

const AdvancedFilterProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)

	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		let metadataGird = context.metadataGird
		let formData = {
			...{
				defaultShowMore: context.metadataGird.appGridLayout.appGridSearch.defaultShowMore,
				labelWidth: context.metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.labelWidth,
			},
			...chgData,
		}
		metadataGird.appGridLayout.appGridSearch.defaultShowMore = formData.defaultShowMore
		metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.labelWidth = formData.labelWidth
		context.setMetadataGrid({ ...metadataGird })
	}
	let propertyFormItemList = [
		{
			field: 'defaultShowMore',
			isSave: true,
			req: true,
			label: '是否默认展开',
			type: 'Radio',
			dataType: 'boolean',
		},
		{
			field: 'labelWidth',
			isSave: true,
			req: true,
			label: '标签宽度',
			dataType: 'number',
			type: 'Input',
			format: '#,###',
		},
	] as AppFormItemProps[]
	return (
		<PropertyForm
			key={context.currSelectd.field}
			formData={{
				defaultShowMore: context.metadataGird.appGridLayout.appGridSearch.defaultShowMore,
				labelWidth: context.metadataGird.appGridLayout.appGridSearch.appGridAdvancedSearch.labelWidth,
			}}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

const QuickFilterFieldProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	let appGridCommonSearchItem = context.metadataGird.appGridLayout.appGridSearch.appGridCommonSearch.appGridCommonSearchItemList.find(
		item => item.field === context.currSelectd.field
	)
	if (!appGridCommonSearchItem) return <EmptyPropertyForm />
	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let metadataGird = context.metadataGird
		appGridCommonSearchItem.label = value
		context.setMetadataGrid({ ...metadataGird })
	}
	let propertyFormItemList = [
		{ field: 'label', isSave: true, req: true, label: '显示名称', type: 'Input' },
	] as AppFormItemProps[]
	return (
		<PropertyForm
			key={context.currSelectd.field}
			formData={{
				label: appGridCommonSearchItem.label,
			}}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProperty}
		/>
	)
}

const ProjectFilterProperty = () => {
	const context = useContext(AppGridLayoutDesigerContext)
	const [entityList, setEntityList] = useState([])
	const loadEntityList = async () => {
		let res = await api.modeling.entity.getList({ systemCode: '00' })
		setEntityList(res)
	}
	useEffect(() => {
		loadEntityList()
	}, [])

	const chgProjectFilterProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		let metadataGird = context.metadataGird
		let formData = {
			...{
				projectFilter: context.metadataGird.appGridLayout.appGridSearch.projectFilter,
				projectFilterLabel: context.metadataGird.appGridLayout.appGridSearch.projectFilterLabel,
				projectFilterType: context.metadataGird.appGridLayout.appGridSearch.projectFilterType,
			},
			...chgData,
		}

		metadataGird.appGridLayout.appGridSearch.projectFilter = formData.projectFilter
		metadataGird.appGridLayout.appGridSearch.projectFilterLabel = formData.projectFilterLabel
		metadataGird.appGridLayout.appGridSearch.projectFilterType = formData.projectFilterType
		context.setMetadataGrid({ ...metadataGird })
	}
	let propertyFormItemList = [
		{ field: 'projectFilter', isSave: true, req: true, label: '启用项目筛选', type: 'Radio', dataType: 'boolean' },
		{ field: 'projectFilterLabel', isSave: true, req: true, label: '标题', type: 'Input' },
		{
			field: 'projectFilterType',
			isSave: true,
			req: true,
			label: '选择范围',
			type: 'Radio',
			dataType: 'number',
			appFormItemOptionList: [{ value: 1, label: '公司' }, { value: 2, label: '项目' }],
		},
	] as AppFormItemProps[]
	return (
		<PropertyForm
			formData={{
				projectFilter: context.metadataGird.appGridLayout.appGridSearch.projectFilter,
				projectFilterLabel: context.metadataGird.appGridLayout.appGridSearch.projectFilterLabel,
				projectFilterType: context.metadataGird.appGridLayout.appGridSearch.projectFilterType,
			}}
			propertyFormItemList={propertyFormItemList}
			onChange={chgProjectFilterProperty}
		/>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/AppGridLayoutBodyDesiger.tsx